<template>
  <el-cascader
      style="width: 100%"
      v-model="current"
      :options="options"
      :placeholder="placeholder"
      filterable
      @change="handleChange"></el-cascader>
</template>

<script>
import {toTreeData} from "@/utils/common";

export default {
  name: "AreaSelect",
  props: {
    value: Array,
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data() {
    return {
      current: [],
      options: []
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.current = val
      }
    }
  },
  created() {
    this.$request.get('/Website/areaList')
        .then(res => {
          if (res.code === 0) {
            this.options = toTreeData({
              data: res.data.map(d => {
                d.value = d.areaId
                d.label = d.name
                return d
              }),
              idField: 'areaId',
              parentIdField: 'parentId'
            })
          }
        })
  },
  methods: {
    /**
     * 选定
     * @param value
     */
    handleChange(value) {
      this.$emit('input', value)
    }
  }
}
</script>
